module.exports = __webpack_public_path__ + "static/media/arrow_drop_up.7bf40005.svg";